/**
 * theme-hexfield.js
 * Async bundle — decorative animated hexagon background.
 *
 * Size: tiny (no external deps; uses GSAP/ScrollTrigger/ScrollSmoother from core)
 * Load: Asynchronous, non-blocking
 * Triggers: `.hex-field` detected in DOM
 * Depends: theme-core.js (GSAP + ScrollTrigger + ScrollSmoother)
 *
 * Waits until theme-core has decided the ScrollSmoother state
 * (body.smoother-active / body.smoother-disabled) so parallax effects can be
 * registered against a live smoother instance when one exists.
 *
 * @package shi
 */

import { initHexFields } from '../modules/animation/hex-field.js';

if (window.themeHexField) {
  console.log('[HexField] Already loaded - skipping duplicate');
} else {
  console.log('[HexField] Loaded');

  let initialized = false;

  function runInit() {
    if (initialized) return;
    initialized = true;
    initHexFields(document);
  }

  /**
   * ScrollSmoother is created (or explicitly disabled) by theme-core, which
   * marks the decision on <body>. Wait for that so parallax can bind to a real
   * instance; fall back to initialising anyway after a short grace period.
   */
  function waitForSmootherDecision() {
    const decided = () =>
      document.body.classList.contains('smoother-active') ||
      document.body.classList.contains('smoother-disabled') ||
      (window.ScrollSmoother && typeof window.ScrollSmoother.get === 'function' && window.ScrollSmoother.get());

    if (decided()) {
      runInit();
      return;
    }

    let waited = 0;
    const interval = 100;
    const maxWait = 3000;
    const timer = setInterval(() => {
      waited += interval;
      if (decided() || waited >= maxWait) {
        clearInterval(timer);
        runInit();
      }
    }, interval);
  }

  function boot() {
    if (!document.querySelector('.hex-field')) return;
    waitForSmootherDecision();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-scan after AJAX content swaps (e.g. load-more / filtered content).
  document.addEventListener('shi:ajaxContentLoaded', (e) => {
    if (e.detail && e.detail.container) {
      initHexFields(e.detail.container);
    }
  });

  window.themeHexField = {
    init: runInit,
    initHexFields
  };
}
